import { GraphQLClient } from 'graphql-request'

import { config } from '~/config'

/** A bearer-authed GraphQL client against the Zunou core API. */
export function createClient(token: string | null): GraphQLClient {
  return new GraphQLClient(config.graphqlUrl, {
    headers: token ? { authorization: `Bearer ${token}` } : {},
  })
}

/** Normalize the API's presence string into our four buckets. */
export function toPresence(value: unknown): import('./types').Presence {
  // The real API enum is active | busy | offline | hiatus (UserPresence).
  const v = String(value ?? '').toLowerCase()
  if (v === 'active' || v.includes('online') || v === 'available') return 'online'
  if (v === 'busy' || v.includes('away') || v.includes('idle')) return 'away'
  if (v === 'offline' || v === 'hiatus' || v === 'inactive') return 'offline'
  return 'unknown'
}

/** UserKind comes back as an enum case name ("Agent"/"Human"); match loosely. */
export function isAgentKind(kind: unknown): boolean {
  return String(kind ?? '').toUpperCase() === 'AGENT'
}
